import React from 'react';
import { TableRowPlaceholder } from '../tableRowPlaceholder.component';
import { ExpansionPanel, ExpansionPanelDetails,TableCell,Table,TableHead, ExpansionPanelSummary, Typography, TableRow, TableBody} from '@material-ui/core';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SessionTableRow from './sessionTableRow.component';
import _ from 'lodash'
import { withStyles } from "@material-ui/core/styles";
const styles = () => ({
  root: {
    border: "none",
    boxShadow: "none",
    padding: "0"
  },
  title: {
    margin: "5px 0px"
  },
  table: {
    minWidth: "100%"
  },
  lastTable: {
    minWidth: "100%",
    marginBottom: "50px"
  },
  insidepanel: {
    padding: "0px"
  },
  spacing: {
    margin: "9px 0"
  }

});
const sessionFiles = ({session, currentFileId,classes}) => {
  const files = _.filter(
    session.files,
    file => !file.virtualFile && file.active && !file.missing
  );
  const defaultExpanded = _.some(files,(file) => file.id === currentFileId);
  const renderSessionFileRows = () =>{



    if (files.length < 1) {
      return <TableRowPlaceholder text="No joined files in this project" colSpan={3}></TableRowPlaceholder>;
    }

    return files.map(file => (
      <SessionTableRow
        key={file.id}
        sessionId={session.id}
        row={file}
        rowLastActive={currentFileId === file.id}
      />
    ));
  }
  return (
    <ExpansionPanel
      defaultExpanded={defaultExpanded}
      className={classes.root}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography className={classes.title} variant="subtitle1">
                Source Files ({files.length})
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={classes.insidepanel}>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Filename</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell colSpan={4}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{renderSessionFileRows()}</TableBody>
              </Table>
            </ExpansionPanelDetails>
          </ExpansionPanel>
  )
};


export default withStyles(styles)(sessionFiles);
